module.exports = "<div class=\"form-control-feedback error-msg\" *ngIf=\"displayError\">\n  {{errorMsg}}\n</div>\n"